export const CalendarIcon = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17 3.5H16V1.5C16 1.23478 15.8946 0.98043 15.7071 0.792893C15.5196 0.605357 15.2652 0.5 15 0.5C14.7348 0.5 14.4804 0.605357 14.2929 0.792893C14.1054 0.98043 14 1.23478 14 1.5V3.5H6V1.5C6 1.23478 5.89464 0.98043 5.70711 0.792893C5.51957 0.605357 5.26522 0.5 5 0.5C4.73478 0.5 4.48043 0.605357 4.29289 0.792893C4.10536 0.98043 4 1.23478 4 1.5V3.5H3C2.20435 3.5 1.44129 3.81607 0.87868 4.37868C0.316071 4.94129 0 5.70435 0 6.5V7.5H20V6.5C20 5.70435 19.6839 4.94129 19.1213 4.37868C18.5587 3.81607 17.7956 3.5 17 3.5Z"
                fill="#43484A"
            />
            <path
                d="M0 17.5C0 18.2956 0.316071 19.0587 0.87868 19.6213C1.44129 20.1839 2.20435 20.5 3 20.5H17C17.7956 20.5 18.5587 20.1839 19.1213 19.6213C19.6839 19.0587 20 18.2956 20 17.5V9.5H0V17.5Z"
                fill="#43484A"
            />
        </svg>
    );
};
